import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { isNonEmptyString, isNumber } from "../utils/validators.js";
import { InvalidParameterError } from "../utils/errors/index.js";
export function postScore(_x) {
  return _postScore.apply(this, arguments);
}

function _postScore() {
  _postScore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var leaderboardSlug, instanceSlug, userId, score, request, _yield$request, instanceId, currentScore;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            leaderboardSlug = _ref.leaderboardSlug, instanceSlug = _ref.instanceSlug, userId = _ref.userId, score = _ref.score, request = _ref.request;

            if (isNumber(score)) {
              _context.next = 3;
              break;
            }

            throw new InvalidParameterError(1616418954076, 'Parameter "score" must be a number.');

          case 3:
            if (isNonEmptyString(leaderboardSlug)) {
              _context.next = 5;
              break;
            }

            throw new InvalidParameterError(1616418954077, 'Parameter "leaderboardSlug" must be a non-empty string.');

          case 5:
            if (isNonEmptyString(instanceSlug)) {
              _context.next = 7;
              break;
            }

            throw new InvalidParameterError(1616418954078, 'Parameter "instanceSlug" must be a non-empty string.');

          case 7:
            if (isNonEmptyString(userId)) {
              _context.next = 9;
              break;
            }

            throw new InvalidParameterError(1616418954079, 'Parameter "userId" must be a non-empty string.');

          case 9:
            _context.next = 11;
            return request({
              method: 'POST',
              path: "api/v1/leaderboards/".concat(leaderboardSlug, "/score"),
              body: {
                instanceSlug: instanceSlug,
                userId: userId,
                score: score
              }
            });

          case 11:
            _yield$request = _context.sent;
            instanceId = _yield$request.instanceId;
            currentScore = _yield$request.score;
            return _context.abrupt("return", {
              instanceId: instanceId,
              score: currentScore
            });

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _postScore.apply(this, arguments);
}